/** Read a full ISO instant, refusing malformed times and calendar dates. */
function serverTime(value: unknown): number | null {
  if (
    typeof value !== 'string' ||
    !/^\d{4}-\d{2}-\d{2}T(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z|[+-](?:[01]\d|2[0-3]):[0-5]\d)$/.test(
      value
    )
  )
    return null
  const time = Date.parse(value)
  const day = value.slice(0, 10)
  return Number.isFinite(time) &&
    new Date(`${day}T00:00:00Z`).toISOString().slice(0, 10) === day
    ? time
    : null
}

/** Compare a refresh request with the first heartbeat's server time. */
export function reloadAfterBoot(
  bootServerTime: string | null,
  requestedAt: unknown
): boolean {
  const boot = serverTime(bootServerTime)
  const request = serverTime(requestedAt)
  return boot !== null && request !== null && request > boot
}
